import React from 'react';

import { styled } from '@mui/material/styles';

const Container = styled('section')`
  background-color: white;

  .long-copy {
    margin-bottom: 30px;
  }
`;

type Props = {
  className?: string;
};

const About = ({ className }: Props) => (
  <Container className={className} id='about'>
    <div className='row'>
      <h2>Our Tradition</h2>
      <p className='long-copy'>
        Founded on the principles of hard work, integrity, and unparalleled service, we're dedicated
        to providing high-quality cement to our fellow builders, contractors, and industries. We
        pride ourselves on our rigorous quality standards, fair pricing, and the personalized service
        that only a local company can offer.
      </p>
      <p className='long-copy'>
        At Coastal Cement, we're not just your supplier; we're
        your neighbor, committed to your success and the prosperity of our shared community.
      </p>
    </div>
  </Container>
);

export default About;
